import { gql } from '@apollo/client';

/**
 * The portal's announcements — everything not yet expired.
 *
 * Deliberately not iqd-pro-next's `myNotifications`. That is a personal inbox
 * with read tracking and an announcement admin; this is a read-only board a
 * distributor is shown. They look alike and are not the same screen.
 */
export const NOTIFICATIONS = gql`
  query PortalNotifications($today: DateTime!) {
    notifications(filter: { expiresAt_gte: $today }, orderBy: updatedAt_DESC) {
      subject
      description
      updatedAt
    }
  }
`;

export const NOTIFICATION_SUMMARY = gql`
  query PortalNotificationSummary($today: DateTime!) {
    notificationSummary(filter: { expiresAt_gte: $today }) {
      count
    }
  }
`;
